@if (showExitImpersonation) {
  <button (click)="endImpersonation()" class="absolute top-0 left-1/2 w-fit z-10 bg-red-700 rounded-b px-2 text-zinc-50">
    Exit Impersonation
  </button>
}
<body [ngClass]="showExitImpersonation? 'border-2 border-red-700 overflow-hidden': ''">
  <app-nanobar />
  <router-outlet></router-outlet>
</body>
